import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import EnumSelect from 'components/field/EnumSelect';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';
import Alert from 'components/global/Alert';

import BaseForm from './BaseForm';
import * as S from './Tabs.styled';

const BankDetails = ({ isLoading }) => {
	const { watch, setValue, clearErrors } = useFormContext();
	const user = useSelector((state) => state?.user);

	const banksArray = useMemo(
		() => (Array.isArray(user?.generalSettings?.banks) ? user?.generalSettings?.banks : []),
		[user]
	);

	const isFieldsDisabled = useMemo(
		() =>
			!!user.generalSettings?.BankIban ||
			!!user.generalSettings?.BankName ||
			!!user.generalSettings?.BankHolderName,
		[user]
	);

	return (
		<S.SectionContainer>
			<BaseForm title="otoLinkOnboardingBankDetailsTitle">
				<Alert content="otoLinkBankDetailsWarning" showIcon className="mb-2-5" />
				<S.FormContainer>
					<FormItem label="bankName" isLoading={isLoading} toolTip="bankName.descriptionWithOTP" required>
						<EnumSelect
							name="BankName"
							data={banksArray.map((item) => item.name)}
							setValue={(value) => {
								clearErrors('BankName');
								setValue('BankName', value);
								setValue('BankID', banksArray.find((item) => item.name === value).id);
							}}
							placeholder="selectOne"
							value={watch('BankName')}
							valueRemovable={false}
							disabled={isFieldsDisabled}
						/>
					</FormItem>

					<FormItem label="bankHolderName" isLoading={isLoading} required>
						<StringInput name="BankHolderName" disabled={isFieldsDisabled} />
					</FormItem>

					<FormItem label="bankIban" isLoading={isLoading} toolTip="bankIban.message" required>
						<StringInput name="BankIban" disabled={isFieldsDisabled} />
					</FormItem>
				</S.FormContainer>
			</BaseForm>
		</S.SectionContainer>
	);
};

export default BankDetails;
